module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addressNotCorrect":"Incorrect address","addressNotFound":"Address not found"}}')
  delete Component.options._Ctor
}
